import { useEffect, useState } from "react";
import { DropdownSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";
import { BadgeCheck, CirclePlus, Trash } from "lucide-react";

type AppCustomPropertySettingsDropdownProps = {
    settings: DropdownSettings
    onChange: (settings: DropdownSettings) => void;
}

export const AppCustomPropertySettingsDropdown = ({settings, onChange} : AppCustomPropertySettingsDropdownProps) => {

    const [choices, setChoices] = useState<string[]>(settings.choices || []);
    const [defaultChoice, setDefaultChoice] = useState<string>("");
    const [flashEmpty, setFlashEmpty] = useState(false);

    useEffect(() => {
        const newSettings = {...settings, default: defaultChoice, choices};
        onChange(newSettings);
    }, [choices, defaultChoice]);

    useEffect(() => {
        if (flashEmpty) {
            setTimeout(() => {
                setFlashEmpty(false);
            }, 1000);
        }
    }, [flashEmpty]);

    return (
        <div className="app-custom-property-settings-container">

            <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Alphabetize
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.alphabetize}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                alphabetize: checked
                            });
                        }}
                    />
                </div>
            </div>

            <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Editable
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.editable}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                editable: checked
                            });
                        }}
                    />
                </div>
            </div>

            <div className="app-custom-property-group">
                <div className="app-custom-property-label">
                    Allow None
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.allowNone}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                allowNone: checked
                            });
                        }}
                    />
                </div>
            </div>
        
            Dropdown Choices: 
            <br />
            <span
                style={{cursor: "pointer", color: "blue"}}
                onClick={() => {
                    if (choices.includes("")) {
                        setFlashEmpty(true);
                        return;
                    } 

                    setFlashEmpty(false);
                    setChoices([...choices, ""]);
                }}
            >
                Add Choice
            </span>
            {/* <CirclePlus 
                size={16}
                onClick={() => {
                    setChoices([...choices, ""]);
                }}
            /> */}

            <div className="app-custom-property-choices">
                {choices.map((choice, index) => {
                    return (
                        <div 
                            key={index}
                            className="app-custom-property-choice"
                        >
                            <input 
                                type="text"
                                placeholder="Enter another choice"
                                autoFocus={index === choices.length - 1}
                                value={choice}
                                onKeyDown={(e) => {
                                    if (index === choices.length -1 && e.key === "Enter") {
                                        setChoices([...choices, ""]);
                                    }
                                }}
                                onChange={(e) => {
                                    const newChoices = [...choices];
                                    newChoices[index] = e.target.value;
                                    setChoices(newChoices);
                                }}
                                style={flashEmpty && choice === "" ? {borderColor: "red"} : {}}
                            />
                            
                            <div 
                                className="app-custom-property-choice-default"
                                style={(defaultChoice && defaultChoice === choice) ? {display: "flex"} : {}}
                            >
                                {choice &&
                                    <BadgeCheck 
                                        size={16}
                                        color={defaultChoice === choice ? "green" : "black"}
                                        onClick={() => {
                                            setDefaultChoice(choice);
                                        }}
                                    />
                                }
                            </div>
                            <div className="app-custom-property-choice-delete">
                                <Trash 
                                    size={16}
                                    onClick={() => {
                                        setChoices(choices.filter((_, i) => i !== index));
                                    }}
                                />
                            </div>
                        </div>
                    )}
                )}
            </div>
          
        </div>
    )
}